module.exports = __webpack_public_path__ + "img/電気回路_5_9_1.ac5c19f3.png";